import {deprecatedTrackEvent} from 'analytics/Analytics';
import {INSIGHTS_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';

import {ParameterType} from './ParameterTypes';

export default function trackParameterTypes(oldType: ParameterType, newType: ParameterType): void {
  deprecatedTrackEvent(INSIGHTS_ANALYTICS_ACTIONS.UPDATED_PARAMETER_TYPE, {
    old_type: oldType,
    new_type: newType,
  });
}
